import React, {useState} from "react";
import Select from 'react-select';

const FormSelectUser = ({data, chosenOption: chosen, options, optionChanged}) => {
    const [chosenOption, setChosenOption] = useState(chosen);
    const [isOpen, setIsOpen] = useState(false);

    const updateOption = (option) => {
        setIsOpen(false);
        setChosenOption(option);
        optionChanged(option);
    }
    const buildUserOption = (user) => ({ value: user, label: user.first_name + ' ' + user.last_name })

    const additionalOptions = [
        { value: {type: "request_gl_responsible_approval"}, label: data?.t?.read("rule.request_approval_from_gl_responsible") },
    ]
    const selectOptions = [
        ...options.map(buildUserOption),
        ...additionalOptions
    ]
    return (
        <Select
            name="user"
            searchable
            isClearable
            placeholder={data?.t?.read("approver")}
            options={selectOptions}
            value={chosenOption ? additionalOptions.find(option => option.value?.type === chosenOption?.type) ?? buildUserOption(chosenOption) : null}
            onChange={(val) => updateOption(val ? val.value : null)}
        />
    )
}

export default FormSelectUser;